/**
 * @deprecated 已挪到 meta下了
 */

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 会员等级
 */
class MemberLevel extends UltMeta {
    PENDING = new Meta(1, "非会员", "非会员");
    BASE = new Meta(2, "基础会员", "砂价运价无限制查看");
    SENIOR = new Meta(3, "高级会员", "AI助理无限制");
    ENTERPRISE_GRADE = new Meta(4, "企业会员", "专属定制");
}
export const MEMBER_LEVEL = new MemberLevel();

/**
 * 会员状态
 */
class MemberState extends UltMeta {
    ACTIVE = new Meta(1, "激活");
    EXPIRY = new Meta(2, "过期");
}
export const MEMBER_STATE = new MemberState();

// 会员功能描述
class MemberPermission extends UltMeta {
    /**
     * 运价指数
     */
    shippingPriceIndexRead = new Meta("shippingPriceIndexRead", "运价指数");
    /**
     * 砂石指数价格
     */
    productTypeIndexRead = new Meta("productTypeIndexRead", "砂石指数价格");
    /**
     * 砂石指数出货量
     */
    productTypeIndexShipmentRead = new Meta("productTypeIndexShipmentRead", "砂石指数出货量");
    /**
     * 会员专享资讯
     */
    memberInformation = new Meta("memberInformation", "会员专享资讯");
    /**
     * 智能助手功能
     */
    assistant = new Meta("assistant", "智能助手功能");
    /**
     * 专职人工服务
     */
    manualService = new Meta("manualService", "专职人工服务");
    // queryMonitor = new Meta("queryMonitor", "查看监控");
    /** 企业子账号 */
    subAccountNum = new Meta("subAccountNum", "子账号");
}
export const MEMBER_PERMISSION = new MemberPermission();

// 激活码状态
class ActivationCodeState extends UltMeta {
    UNUSED = new Meta(1, "未使用");
    USED = new Meta(2, "已使用");
    OVERDUE = new Meta(3, "已过期");
}

export const ACTIVATION_CODE_STATE = new ActivationCodeState();
